export const RQ_GET_ACTIVITY_API = {
  url: 'v1/entity-tag/<%= divisionId %>',
  method: 'GET',
  auth: true,
};
